import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class IncidentTagsApi extends ApiModule {
	constructor() {
		super(ModulesMap.INCIDENT_TAGS, {
			entity: 'incidents_tags',
		})
	}
}
